export default "__VITE_ASSET__D97pdM54__"